import { type Line } from "./models";

export const minimumLength = 20;

/**
 * Checks if the user has drawn a meaningful signature
 * We check if the total length of the lines is greater than a minimum length
*/
export const hasDrawnProperSignature = (lines: Line[]): boolean => {
  const totalLength = getTotalLength(lines);
  return totalLength > minimumLength;
};

export const getTotalLength = (lines: Line[]): number => {
  let totalLength = 0;
  for (const line of lines) {
    if (line.points.length <= 1) { continue; }

    for (let i = 1; i < line.points.length; i++) {
      const point1 = line.points[i - 1];
      const point2 = line.points[i];
      totalLength += Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    }
  }

  return totalLength;
};